import axios, { AxiosInstance, AxiosRequestConfig } from "axios"
import config from "@/config"
import queryString from "../query-string"

const [requestResolve, requestReject] = require("./interceptors/request/browser").default
const [responseResolve, responseReject] = require("./interceptors/response/browser").default

const _setupInterceptors = (axios: AxiosInstance) => {
    // setup interceptor for request
    axios.interceptors.request.use(requestResolve, requestReject)
    // setup interceptor for response
    axios.interceptors.response.use(responseResolve, responseReject)
}

interface AxiosInstance2 extends AxiosInstance {
    get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
    post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
}

const createRequest = (
    type: string,
    noIntgerCeptors = false,
    requstConfig: AxiosRequestConfig = {}
): AxiosInstance2 => {
    const env = process.env.VUE_APP_ENV || "dev"
    // 本地开发需要传递token，请开发时保持登录状态
    const headers: any = {}
    if (env === "dev") {
        headers["X-token"] = localStorage.getItem("token") || ""
    }
    const clientRequest = axios.create({
        ...requstConfig,
        baseURL: config.api[type],
        headers: headers,
        withCredentials: true,
        paramsSerializer: function(params) {
            return queryString.stringify(params)
        }
    })
    if (!noIntgerCeptors) _setupInterceptors(clientRequest)

    return clientRequest
}

export default createRequest
